import * as managers from 'app/mocks/data/park/managers/list'

import { Supplier } from 'app/types/catalogue/supplier'

export const supplier1: Supplier = {
    id: 1,
    name: 'BioCop',
    client: managers.manager1,
    address: '28 rue de Paradis',
    postal_code: '93000',
    city: 'Saint-Denis',
    phone: '0563259685',
    email: 'fournisseur@biocop.com',
    opening_hours: '09:30',
    closing_hours: '19:00',
}

export const supplier2: Supplier = {
    id: 2,
    name: 'TexasFood',
    client: managers.manager1,
    address: '15 Rue Montgomerry',
    postal_code: '75100',
    city: 'Paris',
    phone: '0125362589',
    email: 'fournisseur@texas-food.com',
}

export const supplier3: Supplier = {
    id: 3,
    name: 'KarlsBerg',
    client: managers.manager1,
    address: '15 Rue Parvisi',
    postal_code: '75100',
    city: 'Paris',
    phone: '0125362579',
    email: 'fournisseur@karlsberg.com',
    opening_hours: '09:00',
    closing_hours: '19:00',
}

export const supplier4: Supplier = {
    id: 4,
    name: 'FreshMarket',
    client: managers.manager1,
    address: '22 Avenue des Champs',
    postal_code: '75008',
    city: 'Paris',
    phone: '0145789652',
    email: 'fournisseur@freshmarket.com',
}

export const supplier5: Supplier = {
    id: 5,
    name: 'BioNature',
    client: managers.manager1,
    address: '10 Rue des Oliviers',
    postal_code: '69003',
    city: 'Lyon',
    phone: '0432568741',
    email: 'fournisseur@bionature.fr',
    opening_hours: '07:30',
    closing_hours: '18:30',
}

export const supplier6: Supplier = {
    id: 6,
    name: 'GourmetShop',
    client: managers.manager4,
    address: '5 Boulevard Haussmann',
    postal_code: '75009',
    city: 'Paris',
    phone: '0158963258',
    email: 'fournisseur@gourmetshop.fr',
    opening_hours: '09:30',
    closing_hours: '19:30',
}

export const supplier7: Supplier = {
    id: 7,
    name: 'LocalFarm',
    client: managers.manager4,
    address: '18 Rue des Champs',
    postal_code: '67000',
    city: 'Strasbourg',
    phone: '0388254785',
    email: 'fournisseur@localfarm.com',
    opening_hours: '08:00',
    closing_hours: '18:00',
}

export const supplier8: Supplier = {
    id: 8,
    name: 'SweetDelights',
    client: managers.manager1,
    address: '3 Rue Saint-Honoré',
    postal_code: '75001',
    city: 'Paris',
    phone: '0174256893',
    email: 'fournisseur@sweetdelights.fr',
    opening_hours: '10:00',
    closing_hours: '22:00',
}

export const supplier9: Supplier = {
    id: 9,
    name: 'WineCave',
    client: managers.manager1,
    address: '12 Place Bellecour',
    postal_code: '69002',
    city: 'Lyon',
    phone: '0478563254',
    email: 'fournisseur@winecave.com',
    opening_hours: '10:00',
    closing_hours: '21:00',
}

export const supplier10: Supplier = {
    id: 10,
    name: 'DailyBread',
    client: managers.manager4,
    address: '7 Rue de la Boulangerie',
    postal_code: '13001',
    city: 'Marseille',
    phone: '0491254786',
    email: 'fournisseur@dailybread.fr',
    opening_hours: '06:00',
    closing_hours: '20:00',
}

export const supplier11: Supplier = {
    id: 11,
    name: 'SeafoodMarket',
    client: managers.manager2,
    address: '29 Quai de la Poissonnerie',
    postal_code: '44000',
    city: 'Nantes',
    phone: '0240789652',
    email: 'fournisseur@seafoodmarket.fr',
    opening_hours: '07:00',
    closing_hours: '18:00',
}

export const supplier12: Supplier = {
    id: 12,
    name: 'MeatLovers',
    client: managers.manager2,
    address: '14 Rue de la Boucherie',
    postal_code: '31000',
    city: 'Toulouse',
    phone: '0564789652',
    email: 'fournisseur@meatlovers.fr',
    opening_hours: '08:00',
    closing_hours: '19:00',
}

export const supplier13: Supplier = {
    id: 13,
    name: 'ExoticSpices',
    client: managers.manager2,
    address: '8 Rue des Épices',
    postal_code: '75010',
    city: 'Paris',
    phone: '0154782369',
    email: 'fournisseur@exoticspices.fr',
    opening_hours: '09:00',
    closing_hours: '20:30',
}

export const supplier14: Supplier = {
    id: 14,
    name: 'HealthyChoice',
    client: managers.manager2,
    address: '6 Rue du Bien-être',
    postal_code: '75012',
    city: 'Paris',
    phone: '0178452369',
    email: 'fournisseur@healthychoice.fr',
    opening_hours: '08:30',
    closing_hours: '19:30',
}

export const supplier15: Supplier = {
    id: 15,
    name: 'DairyFarm',
    client: managers.manager2,
    address: '21 Rue des Laitiers',
    postal_code: '54000',
    city: 'Nancy',
    phone: '0383204568',
    email: 'fournisseur@dairyfarm.fr',
    opening_hours: '07:00',
    closing_hours: '17:30',
}

export const supplier16: Supplier = {
    id: 16,
    name: 'PastaWorld',
    client: managers.manager3,
    address: '14 Boulevard de Rome',
    postal_code: '13002',
    city: 'Marseille',
    phone: '0491245789',
    email: 'fournisseur@pastaworld.it',
    opening_hours: '09:00',
    closing_hours: '20:00',
}

export const supplier17: Supplier = {
    id: 17,
    name: 'ChocoDelice',
    client: managers.manager3,
    address: '9 Rue du Cacao',
    postal_code: '67000',
    city: 'Strasbourg',
    phone: '0388569742',
    email: 'fournisseur@chocodelice.fr',
    opening_hours: '10:00',
    closing_hours: '22:00',
}

export const supplier18: Supplier = {
    id: 18,
    name: 'FrozenGoods',
    client: managers.manager3,
    address: '5 Rue du Froid',
    postal_code: '59000',
    city: 'Lille',
    phone: '0320157842',
    email: 'fournisseur@frozengoods.fr',
    opening_hours: '08:00',
    closing_hours: '18:00',
}

export const supplier19: Supplier = {
    id: 19,
    name: 'OrganicHarvest',
    client: managers.manager3,
    address: '28 Avenue de la Nature',
    postal_code: '34000',
    city: 'Montpellier',
    phone: '0467123654',
    email: 'fournisseur@organicharvest.fr',
    opening_hours: '07:30',
    closing_hours: '19:00',
}

export const supplier20: Supplier = {
    id: 20,
    name: 'SnackTime',
    client: managers.manager3,
    address: '3 Rue du Goût',
    postal_code: '33000',
    city: 'Bordeaux',
    phone: '0556124785',
    email: 'fournisseur@snacktime.fr',
    opening_hours: '09:00',
    closing_hours: '21:00',
}

export const supplier21: Supplier = {
    id: 21,
    name: 'BakeryDelight',
    client: managers.manager4,
    address: '16 Rue du Pain',
    postal_code: '44000',
    city: 'Nantes',
    phone: '0240165874',
    email: 'fournisseur@bakerydelight.fr',
    opening_hours: '06:00',
    closing_hours: '18:00',
}

export const supplier22: Supplier = {
    id: 22,
    name: 'CoffeeBean',
    client: managers.manager4,
    address: '10 Rue du Café',
    postal_code: '31000',
    city: 'Toulouse',
    phone: '0563412587',
    email: 'fournisseur@coffeebean.fr',
    opening_hours: '07:00',
    closing_hours: '19:30',
}

export const supplier23: Supplier = {
    id: 23,
    name: 'VeganTreats',
    client: managers.manager4,
    address: '8 Rue des Plantes',
    postal_code: '75014',
    city: 'Paris',
    phone: '0154639874',
    email: 'fournisseur@vegantreats.fr',
    opening_hours: '10:00',
    closing_hours: '21:00',
}

export const supplier24: Supplier = {
    id: 24,
    name: 'CheeseMasters',
    client: managers.manager4,
    address: '2 Place du Fromage',
    postal_code: '25000',
    city: 'Besançon',
    phone: '0381754896',
    email: 'fournisseur@cheesemasters.fr',
    opening_hours: '09:00',
    closing_hours: '19:00',
}

export const supplier25: Supplier = {
    id: 25,
    name: 'SushiCorner',
    client: managers.manager4,
    address: '12 Rue des Sushis',
    postal_code: '69007',
    city: 'Lyon',
    phone: '0478265987',
    email: 'fournisseur@sushicorner.fr',
    opening_hours: '11:00',
    closing_hours: '23:00',
}

export const supplier26: Supplier = {
    id: 26,
    name: 'FruitHeaven',
    client: managers.manager5,
    address: '45 Rue des Vergers',
    postal_code: '13008',
    city: 'Marseille',
    phone: '0491256897',
    email: 'fournisseur@fruitheaven.fr',
    opening_hours: '07:00',
    closing_hours: '18:30',
}

export const supplier27: Supplier = {
    id: 27,
    name: 'BBQKing',
    client: managers.manager5,
    address: '18 Avenue du Grill',
    postal_code: '75015',
    city: 'Paris',
    phone: '0178459632',
    email: 'fournisseur@bbqking.fr',
    opening_hours: '12:00',
    closing_hours: '23:30',
}

export const supplier28: Supplier = {
    id: 28,
    name: 'FarmToTable',
    client: managers.manager5,
    address: '3 Chemin des Champs',
    postal_code: '67000',
    city: 'Strasbourg',
    phone: '0388547632',
    email: 'fournisseur@farmtotable.fr',
    opening_hours: '06:30',
    closing_hours: '17:00',
}

export const supplier29: Supplier = {
    id: 29,
    name: 'TropicalTaste',
    client: managers.manager5,
    address: '99 Rue des Îles',
    postal_code: '31000',
    city: 'Toulouse',
    phone: '0563248975',
    email: 'fournisseur@tropicaltaste.fr',
    opening_hours: '08:00',
    closing_hours: '20:00',
}

export const supplier30: Supplier = {
    id: 30,
    name: 'SweetBakery',
    client: managers.manager5,
    address: '22 Boulevard du Sucre',
    postal_code: '44000',
    city: 'Nantes',
    phone: '0240157896',
    email: 'fournisseur@sweetbakery.fr',
    opening_hours: '06:00',
    closing_hours: '19:00',
}
